import { useState, useEffect, useId } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import IconArrow from "assets/svg/chevron_right_black.svg";

import { Listbox } from "@headlessui/react";

import CheckBoxItem from "components/common/checkbox-item";

import styles from "./styles.module.css";

const CheckboxDropdown = ({
  placeHolder,
  options,
  onChange,
  buttonClass,
  listClass,
  disabled,
  reset,
  handleDropdownButton,
  placeHolderClass,
  icon,
  showCheckBoxFooter,
  showImage,
  displayClass,
  titleClass,
  showDivider,
  dividerClass,
  showOnlyText,
  iconClass,
}) => {
  const dropdownClass = classNames({
    [styles.dropdown]: true,
    [buttonClass]: buttonClass,
  });

  const listClasses = classNames({
    [styles.list]: true,
    [listClass]: listClass,
  });

  const placeHolderClasses = classNames({
    [styles.placeholder]: true,
    [placeHolderClass]: placeHolderClass,
  });

  const dividerClasses = classNames({
    [styles.dividerContainer]: true,
    [dividerClass]: dividerClass,
  });

  const [selectedOptions, setSelectedOptions] = useState([]);

  const id = useId();

  useEffect(() => {
    setSelectedOptions([]);
  }, [reset]);

  const handleOptionChange = (option) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((o) => (o.key || o.id) !== (option.key || option.id)));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const isParentChecked = (option) => {
    if (selectedOptions.includes(option) || option?.checked === true) {
      return true;
    }
  };

  useEffect(() => {
    onChange && onChange(selectedOptions);
  }, [selectedOptions]);

  return (
    <Listbox value={selectedOptions} multiple disabled={disabled}>
      <Listbox.Button className={dropdownClass} onClick={handleDropdownButton}>
        <span className={styles.buttoncontent}>
          {!showOnlyText && selectedOptions.length ? (
            <span>{selectedOptions.map((option) => option.value || option?.name).join(", ")}</span> || (
              <span className={placeHolderClasses}>{placeHolder || "Seçiniz"}</span>
            )
          ) : (
            <span className={placeHolderClasses}>{placeHolder}</span>
          )}
        </span>
        <span className={styles.icon}>{icon || <IconArrow />}</span>
      </Listbox.Button>

      <Listbox.Options className={listClasses}>
        {options?.map((option, index) => (
          <div key={`${id}-fragment-${index}`}>
            <Listbox.Option
              key={`${id}-option-${index}`}
              value={option?.value || option?.name}
              className={({ active }) => `${styles.optionpadding} ${active && styles.optionselected}`}
            >
              <CheckBoxItem
                title={option.value || option?.name}
                name={option?.id}
                onChange={() => handleOptionChange(option)}
                checkBoxClass={option?.childs && styles.parentClass}
                checked={isParentChecked(option)}
                showImage={showImage}
                showCheckBoxFooter={showCheckBoxFooter}
                displayClass={displayClass}
                iconClass={iconClass}
                titleClass={titleClass}
              />
            </Listbox.Option>
            {showDivider && options.length !== index + 1 && (
              <div className={dividerClasses} key={`${id}-divider-${index}`}></div>
            )}
          </div>
        ))}
      </Listbox.Options>
    </Listbox>
  );
};

CheckboxDropdown.propTypes = {
  options: PropTypes.any,
  placeHolder: PropTypes.any,
  placeHolderClass: PropTypes.any,
  onChange: PropTypes.any,
  buttonClass: PropTypes.any,
  listClass: PropTypes.any,
  disabled: PropTypes.bool,
  handleDropdownButton: PropTypes.func,
  reset: PropTypes.any,
  lengthShow: PropTypes.any,
  isInput: PropTypes.bool,
  icon: PropTypes.any,
  showCheckBoxFooter: PropTypes.any,
  showImage: PropTypes.any,
  displayClass: PropTypes.any,
  titleClass: PropTypes.any,
  showDivider: PropTypes.any,
  dividerClass: PropTypes.string,
  showOnlyText: PropTypes.any,
  iconClass: PropTypes.any,
};

export default CheckboxDropdown;
